import { Box } from "@mui/material";
import { useContext } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { useTranslation } from "react-i18next";

export default function ArchieContextBar() {
  const { t } = useTranslation(["archie"]);
  const { user } = useContext(AuthContext);
  const hasArchie = user?.hasFeatureFlag("Archie") ?? false;

  if (!hasArchie) return null;

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 2,
        py: 1,
        borderTop: "1px solid var(--archie-border)",
        backgroundColor: "var(--archie-bg)",
        flexShrink: 0,
      }}
    >
      {/* Archie avatar */}
      <Box
        sx={{
          width: 28,
          height: 28,
          borderRadius: "50%",
          background: "var(--archie-gradient)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Box
          component="svg"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth={1.75}
          strokeLinecap="round"
          strokeLinejoin="round"
          sx={{ width: 14, height: 14, color: "#fff" }}
        >
          <path d="M12 2a4 4 0 0 0-4 4v2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-2V6a4 4 0 0 0-4-4z" /><circle cx="9" cy="13" r="1" /><circle cx="15" cy="13" r="1" />
        </Box>
      </Box>

      {/* Input */}
      <Box
        component="input"
        type="text"
        placeholder={t("archie:askAboutInteraction")}
        disabled
        sx={{
          flex: 1,
          fontSize: "0.8125rem",
          fontFamily: "inherit",
          color: "var(--archie-text)",
          backgroundColor: "transparent",
          border: "none",
          outline: "none",
          cursor: "not-allowed",
          "&::placeholder": {
            color: "var(--archie-text)",
            opacity: 0.6,
          },
        }}
      />
    </Box>
  );
}
